document.addEventListener('DOMContentLoaded', function () {
  // Reveal the video only once it actually plays; on failure the poster stays.
  document.querySelectorAll('.password-hero__video').forEach(function (video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.pause();
      return;
    }

    video.addEventListener(
      'playing',
      function () {
        video.classList.add('is-playing');
      },
      { once: true }
    );

    var attempt = video.play();
    if (attempt !== undefined) {
      attempt.catch(function () {
        // Autoplay refused (iOS Low Power Mode, data saver). Poster remains.
      });
    }
  });

  // Build the customer tag string from server-rendered values only.
  document.querySelectorAll('.password-hero__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var tagsInput = form.querySelector('input[name="contact[tags]"]');
      if (!tagsInput) return;

      // Timestamped so a resubmission can be told apart from the original.
      // Shopify appends tags rather than replacing them, so without this there
      // is no way to know which shopping-* tag is the customer's latest choice.
      var tags = ['password-signup'];

      var country = form.querySelector('select[id^="PasswordHeroCountry"]');
      if (country && country.value) {
        tags.push('country-' + country.value);
      }

      var pref = form.querySelector('input[name="shopping_preference"]:checked');
      if (pref && pref.value) {
        tags.push('shopping-' + pref.value);
      }

      tagsInput.value = tags.join(', ');
    });
  });
});
